// extracted by mini-css-extract-plugin
export var avatarContainer = "_ch-0";
export var avatarTypingWave = "_ch-i";
export var gray = "_ch-f";
export var green = "_ch-c";
export var icon = "_ch-9";
export var image = "_ch-1";
export var lg = "_ch-6";
export var md = "_ch-5";
export var presenceDot = "_ch-b";
export var red = "_ch-d";
export var sm = "_ch-4";
export var status = "_ch-a";
export var typingDot = "_ch-h";
export var typingPill = "_ch-g";
export var xl = "_ch-7";
export var xs = "_ch-3";
export var xxl = "_ch-8";
export var xxs = "_ch-2";
export var yellow = "_ch-e";